module.exports = __webpack_public_path__ + "img/royals.5c16fd8a.svg";